import { execAdmin } from '@src/apis/reware/utils';
import type {
  StartPricingImportMutation,
  StartPricingImportMutationVariables,
} from '@src/types/__generated/rewareAdminTypes';

const gql = String.raw;

/**
 * Start a pricing import session.
 * Creates a new PricingDiscount record and returns its ID.
 * Call addToPricingImport to add rules to this import.
 */
export const startPricingImport = async ({
  partnerId,
  pricingType,
}: StartPricingImportMutationVariables) => {
  const query = gql`
    mutation startPricingImport(
      $partnerId: Int!
      $pricingType: String!
    ) {
      partner(id: $partnerId) {
        startPricingImport(pricingType: $pricingType) {
          pricingDiscountId
        }
      }
    }
  `;

  const data = await execAdmin<StartPricingImportMutationVariables, StartPricingImportMutation>(
    query,
    { variables: { partnerId, pricingType } }
  );

  const result = data.partner?.startPricingImport;
  if (result?.pricingDiscountId == null) {
    throw new Error(
      `startPricingImport: unexpected response — partner.startPricingImport.pricingDiscountId is ${result?.pricingDiscountId === null ? 'null' : 'undefined'} (partnerId=${partnerId}, pricingType=${pricingType})`
    );
  }

  return { pricingDiscountId: result.pricingDiscountId };
};
